import { directive, Directive } from 'lit/directive.js';
import { assertsIsElementPartInfo } from './directive-util';
const directiveName = 'onResize';
export const onResize = directive(class extends Directive {
    constructor(partInfo) {
        super(partInfo);
        this.resizeObserver = new ResizeObserver((entries) => this.fireCallback(entries));
        assertsIsElementPartInfo(partInfo, directiveName);
    }
    fireCallback(entries) {
        var _a;
        const resizeEntry = entries[0];
        if (!resizeEntry) {
            console.error(entries);
            throw new Error(`${directiveName} observation triggered but the first entry was empty.`);
        }
        (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, { target: resizeEntry.target, contentRect: resizeEntry.contentRect });
    }
    update(partInfo, [callback]) {
        assertsIsElementPartInfo(partInfo, directiveName);
        this.callback = callback;
        const newElement = partInfo.element;
        // if the element changes we need to observe the new one
        if (newElement !== this.element) {
            if (this.element) {
                this.resizeObserver.unobserve(this.element);
            }
            this.resizeObserver.observe(newElement);
            this.element = newElement;
        }
        return this.render(callback);
    }
    render(callback) {
        return undefined;
    }
});
